var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1297 14.8844L16.7448 3.00037H20.0647L19.6797 14.8844H17.1297ZM18.4047 20.9948C17.226 20.9948 16.1915 20.2249 16.1915 18.8778C16.1915 17.5306 17.226 16.7848 18.4047 16.7848C19.5595 16.7848 20.618 17.5306 20.618 18.8778C20.618 20.2249 19.5595 20.9948 18.4047 20.9948Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93433 3.68396C13.4073 3.68396 15.2905 5.59166 15.2905 7.91513C15.2905 11.7794 10.6191 11.7061 10.6191 14.7877H8.05109C8.05109 10.4587 11.8909 10.9234 11.8909 8.47766C11.8909 7.23032 11.0594 6.56996 9.543 6.56996C8.22229 6.56996 6.51026 7.13249 5.45858 8.08633L4.38245 5.49382C5.62979 4.63781 7.48856 3.68396 9.93433 3.68396ZM9.34734 21C10.5458 21 11.6219 20.2173 11.6219 18.8477C11.6219 17.4781 10.5458 16.7199 9.34734 16.7199C8.14892 16.7199 7.09724 17.4781 7.09724 18.8477C7.09724 20.2173 8.14892 21 9.34734 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMini);
export default __webpack_public_path__ + "static/media/question-mini.8530d4d2019690e70dcffe82eae1c4bb.svg";
export { ForwardRef as ReactComponent };